import * as types from "./types";

export const savePersonas = (pageNumber, totalRecords, data) => (dispatch) =>
    dispatch({ type: types.SAVE_PERSONAS, payload: { pageNumber, totalRecords, data } });
export const clearPersonas = () => (dispatch) =>
    dispatch({ type: types.CLEAR_PERSONAS });